/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.user.job.profiles.rpc.AppUserPersonas
 */

export const getUserPersonasRpc = {
  serviceName: 'com.hubspot.user.job.profiles.rpc.AppUserPersonas',
  rpcName: 'getUserPersonas',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABsTAL_BQUpMVzvyVkUcQVt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};